module.exports = __webpack_public_path__ + "static/indevco-app-preview-a823eb877b6cfb3da2d6f8ec1caed89d.png";